import { Subject } from 'rxjs';
import { Directive, inject, OnDestroy, signal } from '@angular/core';
import { GlobalService } from '../services/global';

@Directive()
export class BaseClass implements OnDestroy {
  protected componentDestroyed$: Subject<void> = new Subject<void>();

  public globalService = inject(GlobalService);

  public isBrowser = signal(this.globalService.isBrowser());

  public isServer = signal(this.globalService.isServer());

  // constructor() {
  //   // /// wrap the ngOnDestroy to be an Observable. and set free from calling super() on ngOnDestroy.
  //   // let _$ngDestroy = this.ngOnDestroy;
  //   // // console.log('[BaseClass]', 'Constructor');
  //   // this.ngOnDestroy = () => {
  //   //   console.log('[BaseClass]', 'overwritten ngOnDestroy');
  //   //   _$ngDestroy.bind(this)();
  //   //   this.componentDestroyed$.next();
  //   //   this.componentDestroyed$.complete();
  //   //   //_$();
  //   // };
  // }

  /// placeholder of ngOnDestroy. no need to do super() call of extended class.
  ngOnDestroy() {
    // console.log('[BaseClass]', 'overwritten ngOnDestroy', this);
    this.componentDestroyed$.next();
    this.componentDestroyed$.complete();
  }
}
